export { default } from './InputNumeral'
